import React, { Component } from "react";
import Header from "../../Header/Header";
import Previousresult from "./Previousresult";
import PreviousDrawShows from "./previousdrawshow";
import { withTranslation } from 'react-i18next';
import Ourwinners from "./Ourwinners";
import Weeklylive from "./Weeklylive";
import FAQDraws from "../Helmet/FAQDraws";
import DrawsHelmetMy from "../Helmet/DrawsHelmetMy";
import DrawsHelmetOthers from "../Helmet/DrawsHelmetOthers";
import { commonClass } from "../../helpers/commonClass";
import HomeSlidTabs from "../Home/HomeSlidTabs";
import { history } from "../../helpers/history";

class Mydraws extends Component {
    constructor(props) {
        super(props);
        const tabid = localStorage.getItem('drawtabId') ? localStorage.getItem('drawtabId') : 1;
        const _UserCountry = localStorage.getItem('cloc') ? JSON.parse(localStorage.getItem('cloc')) : {};
        if (tabid == null || tabid == "")
            this.state = {
                setTabId: 1, drawType: (props.drawtype == '12' ? '9' : props.drawtype),
                _dbdrawType: props.drawtype,
                UserCountry: _UserCountry
            }
        else
            this.state = {
                setTabId: tabid, drawType: (props.drawtype == '12' ? '9' : props.drawtype),
                _dbdrawType: props.drawtype,
                UserCountry: _UserCountry
            }
    }
    changeMenu = (tabId) => {
        this.setState({ setTabId: tabId });
    }


    render() {
        const { t } = this.props;
        return (
            <>
                {/* {process.env.REACT_APP_MODE != "development" &&
                    Object.keys(this.state.UserCountry).length > 0 && this.state.UserCountry.country && this.state.UserCountry.country.toLowerCase() == 'my' ?
                    <DrawsHelmetMy drawType={this.state.drawType} />
                    :
                    <DrawsHelmetOthers drawType={this.state.drawType} />
                } */}

                {process.env.REACT_APP_MODE != "development" &&
                    <DrawsHelmetOthers drawType={this.state.drawType} />
                }
                <Header />
                <div class="container">
                    <HomeSlidTabs />
                    <div class="rht bg2 content">
                        <div class="bredCrums">
                            <ul>
                                <li><a onClick={() => { history.push('/') }}>  {t('lblHome')} <img src="./assets/img/icons/right-angle.png" /></a></li>
                                <li><a class="active">{commonClass.IDWiseGameName(this.state.drawType)}</a></li>
                            </ul>
                        </div>
                        <div class={`lottoBanner lto-${this.state._dbdrawType} lto-${this.state._dbdrawType}-bg-gradiant`}>
                            <div class="lottoLogo">
                                <img src={`./assets/img/gamesBg/${commonClass.IDWiseGameLogo(this.state._dbdrawType, 'others')}`} className="margin-0-auto" />
                                {/* {this.state._dbdrawType == 1 ? <img src="./assets/img/play-lotto-logo.png" alt="draw date" className="margin-0-auto" />
                                    : this.state._dbdrawType == 2 ? <img src="./assets/img/mini-lotto.png?v0.1" alt="draw date" className="margin-0-auto" />
                                        : this.state._dbdrawType == 3 ? <img src="./assets/img/play-lotto-logo.png?v0.1" alt="draw date" className="margin-0-auto" />
                                            : this.state._dbdrawType == 4 ? <img src="./assets/img/play-lotto-logo.png" alt="draw date" className="margin-0-auto" />
                                                : this.state._dbdrawType == 5 ? <img src="./assets/img/play-lotto-logo.png" alt="draw date" className="margin-0-auto" />
                                                    : this.state._dbdrawType == 6 ? <img src="./assets/img/play-lotto-logo.png" alt="draw date" className="margin-0-auto" />
                                                        : <img src="./assets/img/Fortune4_Fortune5_extend.png?v0.1" alt="draw date" className="margin-0-auto" />} */}
                            </div>
                        </div>
                        <div class="myAccount">
                            <div class="myAccTabs">
                                <ul>
                                    <li><a className={(this.state.setTabId == 1) ? "active" : ""} onClick={() => this.changeMenu(1)}><img src="./assets/img/icons/tabs-Past-Draw-Results.png" />{t('lblPastDrawRes')}</a></li>
                                    <li><a className={(this.state.setTabId == 2) ? "active" : ""} onClick={() => this.changeMenu(2)}><img src="./assets/img/icons/tabs-Past-Draw-Shows.png" />{t('lblPastDrawShow')}</a></li>
                                    <li><a className={(this.state.setTabId == 3) ? "active" : ""} onClick={() => this.changeMenu(3)}><img src="./assets/img/icons/tabs-Our-Winners.png" />{t('lblOurWinner')}</a></li>
                                    <li><a className={(this.state.setTabId == 4) ? "active" : ""} onClick={() => this.changeMenu(4)}><img src="./assets/img/icons/tabs-Weekly-Live-Stream.png" />{t('lblWeeklyLive')}</a></li>
                                </ul>
                                <div class="myAccCont">
                                    {this.state.setTabId == 1 && <Previousresult drawtype={this.state.drawType} send_db_id={this.state._dbdrawType} />}
                                    {this.state.setTabId == 2 && <PreviousDrawShows drawtype={this.state.drawType} send_db_id={this.state._dbdrawType} />}
                                    {this.state.setTabId == 3 && <Ourwinners drawtype={this.state.drawType} send_db_id={this.state._dbdrawType} />}
                                    {this.state.setTabId == 4 && <Weeklylive drawtype={this.state.drawType} send_db_id={this.state._dbdrawType} />}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                {/* <div className="wrap2">
                    <h2 className="headding3 pastDrawHead font-[portilla]">{t('lblPastDrawRes')}</h2>
                    <div className="profile">
                        <ul className={this.state.drawType == 1 ? "gameTabs fortuneTabs" : this.state.drawType == 2 ? "gameTabs superTabs" : this.state.drawType == 4 ? "gameTabs luckyTabs" : this.state.drawType == 5 ? "gameTabs dreamTabs" : this.state.drawType == 6 ? "gameTabs pick3Tabs" : "gameTabs magicTabs"}>
                            <li className={(this.state.setTabId == 1) ? "drwTabItem1 tabActive" : "drwTabItem1"}><a className="proLiPos7" onClick={() => this.changeMenu(1)}>{t('lblPastDrawRes')}</a></li>
                            <li className={(this.state.setTabId == 2) ? "drwTabItem2 tabActive" : "drwTabItem2"}><a className="proLiPos8" onClick={() => this.changeMenu(2)}>{t('lblPastDrawShow')}</a></li>
                            <li className={(this.state.setTabId == 3) ? "drwTabItem3 tabActive" : "drwTabItem3"}><a className="proLiPos9" onClick={() => this.changeMenu(3)}>{t('lblOurWinner')}</a></li>
                            <li className={(this.state.setTabId == 4) ? "drwTabItem4 tabActive" : "drwTabItem4"}><a className="proLiPos10" onClick={() => this.changeMenu(4)}>{t('lblWeeklyLive')}</a></li>
                        </ul>
                        <select name="draw-results-menu" className="pUserMenuMobile">
                            <option value="past_results" onClick={() => this.changeMenu(1)}>{t('lblPastDrawRes')}</option>
                            <option value="past_shows" onClick={() => this.changeMenu(2)}>{t('lblPastDrawShow')}</option>
                            <option value="winners" onClick={() => this.changeMenu(3)}>{t('lblOurWinner')}</option>
                            <option value="live_stream" onClick={() => this.changeMenu(4)}>{t('lblWeeklyLive')}</option>
                        </select>
                        {this.state.setTabId == 1 && <Previousresult drawtype={this.state.drawType} send_db_id={this.state._dbdrawType} />}
                        {this.state.setTabId == 2 && <PreviousDrawShows drawtype={this.state.drawType} send_db_id={this.state._dbdrawType} />}
                        {this.state.setTabId == 3 && <Ourwinners drawtype={this.state.drawType} send_db_id={this.state._dbdrawType} />}
                        {this.state.setTabId == 4 && <Weeklylive drawtype={this.state.drawType} send_db_id={this.state._dbdrawType} />}
                    </div>
                    {Object.keys(this.state.UserCountry).length > 0 && this.state.UserCountry.country && this.state.UserCountry.country.toLowerCase() == 'my' &&
                        <FAQDraws gamegroupID={this.state.drawType} />}
                </div> */}
            </>
        );
    }
}

export default (withTranslation()(Mydraws));